export default __webpack_public_path__ + "static/media/dinner3.e144a042.png";